module.exports = __webpack_public_path__ + "img/banner-1-m.a584280b.jpg";